import React from 'react';
import UndsenHurunguTovchoo from './undsenHurunguTovchoo';

const PageList = () => <UndsenHurunguTovchoo />;

export default PageList;
